import classNames from "classnames";
import React from "react";

const SectionCard = ({ children, className, size='md' }) => {
    return (
        <div className={classNames(`bg-[#1A1D21] rounded-[20px] lg:rounded-[60px] relative `, {
            'p-10 lg:p-20': size === 'lg',
            'p-10 lg:px-20': size === 'md',
            'p-10 lg:p-16': size === 'sm',
            'p-10 lg:py-12': size === 'xs',
        },  className)}>
            {children}
        </div>

    )
}

export default SectionCard;